import { createSelector } from "reselect";
import { initialState } from "./reducer";

const reducerState = (state) => state.CouponDetail || initialState;

const makeCouponDetailSelectField = (field) =>
  createSelector(reducerState, (couponDetailState) => couponDetailState[field]);

export { reducerState, makeCouponDetailSelectField };
